import { createFileRoute } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { z } from "zod";
import ServicesTable from "@/components/services/services-table";

const servicesSearchSchema = z.object({
  page: z.number().optional().default(1),
  search: z.string().optional(),
  category: z.string().optional(),
  status: z.string().optional(),
});

export const Route = createFileRoute("/_authenticated/services/_layout/")({
  validateSearch: servicesSearchSchema,
  component: ServicesPage,
});

function ServicesPage() {
  const searchParams = Route.useSearch();

  return (
<RouteGuardPermissions
      permissions={[{ module: "services", actions: ["read"] }]}>
      
    <div className="space-y-4">
      <ServicesTable
        currentPage={searchParams.page}
        basePath="/services"
        searchParams={searchParams}
      />
    </div>
  
    </RouteGuardPermissions>
  );
}
